module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box popular-search"
  }, [_c('h2', {
    staticClass: "search-box-title"
  }, [_vm._v("인기 검색어")]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('div', {
    staticClass: "loading-spinner"
  }), _vm._v(" "), _c('span', {
    staticClass: "loading-text"
  }, [_vm._v("인기 검색어를 불러오는 중...")])]) : _c('ol', {
    staticClass: "search-list rank"
  }, _vm._l((_vm.popularSearches), function(item) {
    return _c('li', {
      key: item.rank
    }, [_c('a', {
      attrs: {
        "href": "#",
        "aria-label": item.ariaLabel,
        "title": item.ariaLabel
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleSearchKeyword(item.keyword)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.keyword) + "\n      ")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-527d78f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/search/PopularSearches.vue
// module id = 1398
// module chunks = 6